import { ComponentProps } from 'react';
import { When } from 'react-if';
import { AsyncBoundary } from '@toss/async-boundary';
import { withAsyncBoundary } from '@toss/async-boundary';
import { ExtendedMapTemplate, MapTemplate } from '@zep/types';
import { useTemplates } from '../hooks';
import { MapTemplatesEmpty, MapTemplatesSkeleton } from './MapTemplateFallbacks';
import S from './MapTemplateModal.module.scss';
import { TemplateCard } from './TemplateCard';
const asyncBoundaryProps: ComponentProps<typeof AsyncBoundary> = {
  pendingFallback: <MapTemplatesSkeleton />,
  rejectedFallback: () => <div>Error</div>,
  onError: error => {
    window.alert(error.message);
  }
};
export const OfficialMapTemplates = withAsyncBoundary((props: MapTemplatesProps) => {
  const {
    templates
  } = useTemplates({
    categoryId: props.categoryId,
    isPurchasedView: false,
    suspense: true
  });
  return <MapTemplates {...props} templates={templates} />;
}, asyncBoundaryProps);
export const PurchasedMapTemplates = withAsyncBoundary((props: MapTemplatesProps) => {
  const {
    templates
  } = useTemplates({
    categoryId: props.categoryId,
    isPurchasedView: true,
    suspense: true
  });
  return <MapTemplates {...props} templates={templates} isPurchased={true} />;
}, asyncBoundaryProps);
const MapTemplates = (props: MapTemplatesProps & {
  templates?: MapTemplate[];
  isPurchased?: boolean;
}) => {
  const {
    templates,
    isPurchased = false,
    onSelectTemplate
  } = props;
  return templates?.length ? <div className={S.content} data-sentry-component="MapTemplates" data-sentry-source-file="MapTemplates.tsx">
      {templates.map(template => <TemplateCard key={template.hashId} template={template} variant="mobile" onClick={() => {
      const extendedTemplate: ExtendedMapTemplate = {
        ...template,
        isPurchased
      };
      onSelectTemplate(extendedTemplate);
    }} />)}
    </div> : <When condition={isPurchased} data-sentry-element="When" data-sentry-component="MapTemplates" data-sentry-source-file="MapTemplates.tsx">
      <MapTemplatesEmpty data-sentry-element="MapTemplatesEmpty" data-sentry-source-file="MapTemplates.tsx" />
    </When>;
};
export type MapTemplatesProps = {
  categoryId?: number;
  onSelectTemplate: (mapTemplate: ExtendedMapTemplate | null) => void;
};